<template>
  <div class="bg-white p-12">
    <div class="flex flex-nowrap space-x-20">
      <div class="w-11.5rem h-2.5rem mb-7">
        <img src="@/assets/image/logo.png" class="w-full h-full" />
      </div>
      <el-steps :active="1" align-center class="w-36.5rem step">
        <el-step :title="$t('提交订单')"></el-step>
        <el-step :title="$t('付款')"></el-step>
        <el-step :title="$t('收货')"></el-step>
        <el-step :title="$t('评价')"></el-step>
      </el-steps>
    </div>
    <div v-if="addr_data">
      <div class="font-bold text-xl text-left mb-3">
        {{ $t("选择收货地址") }}
      </div>
      <div>
        <List
          :span="3"
          :data="addr_data"
          v-slot="{ item }"
          :class="{ more: isMore }"
        >
          <Radio
            class="w-full pt-2 pr-1px show flex h-7rem justify-between"
            :item="item"
            v-model="select.v"
          >
            <div class="text-left p-3 overflow-hidden w-5/6">
              <p class="flex items-center">
                <span class="name">{{ item.receiver }}</span>
                <span class="text-gray-400 ml-4 phone">{{ item.phone }}</span>
                <template v-if="item.isdefault">
                  <span class="bg-mainHigh text-white text-xs px-1 ml-8">{{
                    $t("默认")
                  }}</span>
                </template>
              </p>
              <p class="text_display">
                <span v-if="item.area">{{ item.area.names }}</span>
                {{ item.address }}
              </p>
            </div>
            <div
              class="
                mt-2
                text-gray-400 text-sm
                disp
                invisible
                w-1/6
                space-y-3
                pt-2
              "
            >
              <span @click.stop="modify(item)" class="block">
                <i class="iconfont icon-bianji"></i>
                {{ $t("修改") }}
              </span>
              <span @click="setDefault(item)" class="block">{{
                $t("设为默认")
              }}</span>
            </div>
          </Radio>
        </List>
        <div class="flex justify-between text-base pt-3.5 pb-12">
          <div v-if="isMore" @click="isMore = !isMore" class="cursor-pointer">
            <span>{{ $t("展开全部") }}</span>
            <span class="iconfont icon-xiangxia"></span>
          </div>
          <div v-else @click="isMore = !isMore" class="cursor-pointer">
            <span>{{ $t("收起") }}</span>
            <span class="iconfont icon-xiangshang"></span>
          </div>
          <div @click="addMessage" class="cursor-pointer">
            <span class="iconfont icon-tianjia"></span>
            <span>{{ $t("添加收货地址") }}</span>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogModifyVisible" width="30%">
        <AddAddress
          :title="title"
          :addr_message="addr_message"
          v-if="show"
          @remodify="remodify"
        ></AddAddress>
      </el-dialog>
      <el-dialog :visible.sync="dialogAddVisible" width="30%">
        <AddAddress v-if="show" @reload="re_add"></AddAddress>
      </el-dialog>
      <div class="font-bold text-xl text-left mb-3">{{ $t("航班") }}</div>

      <div class="flex">
        <Radio :item="flight_data" v-if="flight_data"></Radio>
      </div>

      <ProductInfo
        class="mt-8"
        :data="product_data"
        :count.sync="count"
      ></ProductInfo>
    </div>
    <div class="mt-8 foot">
      <div></div>
      <div class="text-gray-500 flex flex-col items-start mr-8">
        <p>
          <span>{{ $t("商品总额") }}：</span>
          <span>{{ $p(money_info.goods) }}</span>
        </p>
        <p>
          <span>{{ $t("运费") }}：</span>
          <span>{{ $p(money_info.express) }}</span>
        </p>
        <p>
          <span>{{ $t("促销立减") }}：</span>
          <span>{{ $p(money_info.discount) }}</span>
        </p>
        <p>
          <span>{{ $t("包装费") }}：</span>
          <span>{{ $p(money_info.package) }}</span>
        </p>
        <p>
          <span class="text-blue-400">{{ $t("预估报关报检费") }}：</span>
          <span>{{ $p(money_info.declare) }}</span>
        </p>
        <p class="mt-4">
          <span class="text-left">{{ $t("实际付款") }}：</span>
          <span class="text-red-500 text-3xl ml-0">{{
            $p(money_info.total)
          }}</span>
        </p>
        <div class="text-left pt-5">
          <el-button type="danger" @click="submitForm">{{
            $t("提交订单")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductInfo from "/src/components/product/productInfo.vue";
import List from "@/components/base/list.vue";
import Radio from "@/components/base/radio.vue";
import AddAddress from "@/components/mine/addAddress.vue";

import { onMounted, ref, reactive, computed } from "@vue/composition-api";
import { max, assoc } from "ramda";
export default {
  components: { ProductInfo, List, Radio, AddAddress },
  setup(props, ctx) {
    const title = ref();
    const dialogModifyVisible = ref(false);
    const dialogAddVisible = ref(false);
    const show = ref(true);
    const isMore = ref(true);
    const addr_data = ref();
    // 地址信息
    const reload = async () => {
      const res = await ctx.root.$callapi("user/getAddressList", {
        page: 1,
        size: 50,
      });
      addr_data.value = res.data;
    };

    onMounted(async () => {
      const res = await ctx.root.$callapi("user/getAddressList", {
        page: 1,
        size: 50,
      });
      addr_data.value = res.data;
      select.v = addr_data.value?.items[0]?.id;
    });
    const select = reactive({ v: null });
    // onUpdated(() => {
    //   select.v = addr_data.value?.items[0]?.id
    // })
    // 商品信息发送到子组件
    const pid = ctx.root.$route.params.pid;
    const quantity = ctx.root.$route.params.quantity;
    const product_data = ref();
    onMounted(async () => {
      const res = await ctx.root.$callapi("getProductDetail", { pid });
      product_data.value = res.data;
      product_data.value = assoc("quantity", quantity)(product_data.value);
    });

    // 航班信息
    const flight_data = ref();
    onMounted(async () => {
      const res = await ctx.root.$callapi("getDefaultFlight");
      flight_data.value = res.data;
    });

    // 子组件返回商品数量
    const count = ref(quantity);

    // 计算价格
    const money_info = reactive({
      goods: null,
      express: null,
      discount: null,
      package: null,
      declare: null,
      total: null,
    });

    const flightAdvance = computed(() => flight_data?.value?.advance);

    money_info.goods = computed(
      () => count?.value * product_data?.value?.price
    );
    money_info.express = computed(() =>
      // max(
      //   flightAdvance?.value?.startprice,
      //   flightAdvance?.value?.otherprice *
      //     product_data?.value?.weight *
      //     count?.value
      // )
      0
    );

    money_info.discount = 0;

    money_info.package = computed(() =>
      // max(
      //   flightAdvance.value?.packstartprice,
      //   flightAdvance.value?.packotherprice *
      //     product_data?.value?.weight *
      //     count?.value
      // )
      0
    );
    money_info.declare = computed(() =>
      // max(
      //   flightAdvance.value?.declarestartprice,
      //   flightAdvance.value?.declareotherprice *
      //     product_data?.value?.weight *
      //     count?.value
      // )
      0
    );
    money_info.total = computed(
      () =>
        money_info.goods +
        money_info.express +
        money_info.package +
        money_info.declare -
        money_info.discount
    );
    const addr_message = ref();
    const modify = async (item) => {
      const addr_item = await ctx.root.$callapi("user/getAddress", {
        aid: item.id,
      });
      addr_message.value = addr_item.data;
      title.value = "修改";
      dialogModifyVisible.value = true;
      show.value = false;
      ctx.root.$nextTick(() => {
        show.value = true;
      });
    };
    const remodify = () => {
      reload();
      dialogModifyVisible.value = false;
    };
    const addMessage = () => {
      dialogAddVisible.value = true;
    };
    const re_add = () => {
      reload();
      dialogAddVisible.value = false;
    };
    const setDefault = async (item) => {
      item.isdefault = true;
      item.aid = item.id;
      await ctx.root.$callapi("user/saveAddress", item);
      reload();
    };

    // 提交订单
    const submitForm = async () => {
      if (select.v) {
        ctx.root.$doing();
        const query = {
          address_id: select.v,
          flight_id: flight_data.value.id,
          id2quantity: { [pid]: count.value },
          coupon_id: null,
          scene: "product",
          param: {
            pid: Number(pid),
            quantity: count.value,
          },
        };

        const res = await ctx.root.$callapi("user/createOrder", query);
        ctx.root.$done();
        if (res.code == 0) {
          ctx.root.$router.push({
            name: "OrderDetail",
            params: { id: res.data.oid },
            query: { pay: true },
          });
        }
      } else {
        ctx.root.$toast(ctx.root.$t("您还未选择收货地址"), "warning");
      }
    };
    return {
      addr_data,
      select,
      product_data,
      count,
      flight_data,
      money_info,
      isMore,
      reload,
      dialogModifyVisible,
      title,
      modify,
      show,
      addr_message,
      remodify,
      addMessage,
      dialogAddVisible,
      re_add,
      setDefault,
      submitForm,
    };
  },
};
</script>
<style scoped lang="scss">.foot {
  display: -ms-grid;
  display: grid;
  grid-template-columns: 1fr auto;
}
.more :nth-child(n + 4) {
  display: none;
}
.show:hover .disp {
  visibility: visible;
}
.step ::v-deep .el-step__head.is-process {
  border-color: #c0c4cc;
  color: #c0c4cc;
}
.step ::v-deep .el-step__title.is-process {
  color: #c0c4cc;
  font-weight: normal;
}
.text_display {
  overflow: hidden;
  width: 100%;
  height: 3rem;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}</style>
